import { PhrasePicker, PhrasePickerProps } from '../Toolbar/PhrasePicker';
import { StickerPicker, StickerPickerProps } from '../Toolbar/StickerPicker';
import ImageUpload from '../Toolbar/ImageUpload';
import VideoUpload, { VideoUploadProps } from '../Toolbar/VideoUpload';
import { LazadaFollow } from '../Toolbar/LazadaFollow';
import { ShopeeFollow } from '../Toolbar/ShopeeFollow';
import { AttachmentUploadAction } from '../Toolbar/AttachmentUpload/AttachmentUploadAction';
import KwaiStickerPicker from '../Toolbar/KwaiStickerPicker';
import FileUpload from '../Toolbar/FileUpload';
import { useMessageEditorToolbarFeatures } from '../hooks/useMessageEditorToolbar';
import WhatsAppTemplate from '../Toolbar/WhatsAppTemplate';
import { ProductPicker } from '../Toolbar/ProductPicker';
import { CouponPicker } from '../Toolbar/CouponPicker';

interface LightMessageEditorToolbarProps {
  className?: string;
  targetLang: General.Language;
  showSideFold?: boolean;
  conversation: Conversation.Conversation;
  videoUploadProps: Omit<VideoUploadProps, 'targetLang'>;
  phrasePickerProps: Omit<PhrasePickerProps, 'conversation' | 'onSend'>;
  stickerPickerProps: Omit<StickerPickerProps, 'conversation' | 'onSend'>;
  canSendTemplate: boolean;
  onSend?: () => void;
}

export const LightMessageEditorToolbar = (props: LightMessageEditorToolbarProps) => {
  const {
    conversation,
    targetLang,
    stickerPickerProps,
    videoUploadProps,
    phrasePickerProps,
    canSendTemplate,
    onSend,
  } = props;
  const { channel, followerFlag, controlStatus } = conversation;

  const {
    showAttachmentUpload,
    showPhrasePicker,
    showStickerPicker,
    showVideoUpload,
    showImageUpload,
    showLazadaFollow,
    showShopeeFollow,
    showWaMsgTemplate,
    showProductPicker,
    showCouponPicker,
  } = useMessageEditorToolbarFeatures({ channel, followerFlag });

  return (
    <div className="flex items-center justify-center gap-4">
      {showAttachmentUpload && <AttachmentUploadAction conversation={conversation} />}
      {showStickerPicker &&
        (channel === 'KWAI' ? (
          <KwaiStickerPicker onPick={stickerPickerProps.onEmojiChange} />
        ) : (
          <StickerPicker {...stickerPickerProps} conversation={conversation} onSend={onSend} />
        ))}
      {showImageUpload && <ImageUpload onSend={() => onSend && onSend()} />}
      {showVideoUpload && <VideoUpload {...videoUploadProps} targetLang={targetLang} />}
      {showLazadaFollow && <LazadaFollow conversation={conversation} onSend={onSend} />}
      {showShopeeFollow && <ShopeeFollow conversation={conversation} onSend={onSend} />}
      {channel === 'FACEBOOK' && <FileUpload onSend={onSend} />}
      {showProductPicker && <ProductPicker conversation={conversation} />}
      {showCouponPicker && <CouponPicker conversation={conversation} />}
      {showPhrasePicker && (
        <PhrasePicker {...phrasePickerProps} conversation={conversation} onSend={onSend} />
      )}
      {showWaMsgTemplate && (
        <WhatsAppTemplate
          conversation={conversation}
          canSent={canSendTemplate && controlStatus}
          onSend={onSend}
        />
      )}
    </div>
  );
};
